import React, { forwardRef } from 'react'
import { Dropdown as ReactDropDown, DropdownProps as ReactDropDownProps } from 'primereact/dropdown'
import { Message } from 'primereact/message'
import cn from 'classnames'
import { Tooltip } from 'primereact/tooltip'

import useText from '../../hooks/useText'

export interface DropdownProps extends ReactDropDownProps {
    disabledReason?: string
    error?: string
    infoText?: string
    ['data-testid']?: string
    className?: string
    label?: string
}

export const Dropdown = forwardRef<ReactDropDown, DropdownProps>(
    ({ infoText, disabledReason, className, ...props }: DropdownProps, ref) => {
        const text = useText()
        return (
            <div className={cn('flex flex-column gap-2', className)}>
                {props.label ? (
                    <div className="flex justify-content-between">
                        <label className={cn({ 'required-label': props.required }, 'p-label')} htmlFor={props.id}>
                            {props.label}
                        </label>
                        {infoText && (
                            <>
                                <Tooltip target=".custom-target-dropdown" className="w-2" />
                                <i
                                    style={{ color: 'var(--text-color-info)' }}
                                    className="custom-target-dropdown pi pi-info-circle cursor-pointer"
                                    data-pr-tooltip={infoText}
                                    data-pr-position="bottom"
                                ></i>
                            </>
                        )}
                    </div>
                ) : null}
                <ReactDropDown
                    emptyMessage={text('msgNoResultsFound')}
                    emptyFilterMessage={text('msgNoAvailableOptions')}
                    showClear
                    filter
                    {...props}
                    pt={{
                        root: {
                            className: 'w-full',
                        },
                        input: {
                            'data-testid': `${props.id}-input`,
                        },
                        clearIcon: {
                            'data-testid': `${props.id}-clear-icon`,
                        },
                        panel: {
                            style: { width: '250px' },
                        },
                    }}
                    ref={ref}
                    value={props.value}
                    options={props.options}
                    disabled={props.disabled}
                    data-testid={props.disabled ? `${props.id}-disabled` : `${props.id}`}
                    tooltip={disabledReason}
                    tooltipOptions={{ showOnDisabled: true, className: 'w-2' }}
                    inputId={props.id}
                />

                {props.error && (
                    <Message
                        severity="error"
                        text={props.error}
                        data-testid={`error-text:${props.error}`}
                        className="mt-2 justify-content-start"
                    />
                )}
            </div>
        )
    }
)
